import { Text as Paragraph, Title } from '../../Typography';
import type { IRatingBanner } from '../index';

interface IHeading extends Pick<IRatingBanner, 'ratingData' | 'ratingMsg'> {
  isRatingGiven?: boolean;
  show?: boolean;
}

export const Heading = ({ ratingData, isRatingGiven, ratingMsg, show }: IHeading) => {
  if (!show) {
    return null;
  }
  return (
    <div className="max-w-480 flex flex-col mx-auto mb-2.5">
      <Paragraph className="text-center opacity-70 mb-2.5 md:mb-2.5" tag="div" type="lead">
        {ratingData.rate_this}
      </Paragraph>

      {isRatingGiven && (
        <>
          <Title className="text-center mb-2.5 md:mb-2.5" tag="div" type="sm">
            {ratingMsg.ratingThanks}
          </Title>
          <Paragraph className="text-center" tag="div" type="md">
            {ratingMsg.thanksMessage}
          </Paragraph>
        </>
      )}
      {!isRatingGiven && (
        <Title className="text-center mb-2.5 md:mb-2.5" tag="div" type="sm">
          {ratingData.rating_title}
        </Title>
      )}
    </div>
  );
};
